import ViewportObserverService from "Services/ViewportObserverService";
import { IN_VP_EVENT, OUT_VP_EVENT } from "Constants/eventNames";
import MediaQueryService from "../../js/services/MediaQueryService";
import { MQ_CHANGE_EVENT } from "../../js/constants/eventNames";
import { getCurrentMQ } from "../../js/helper/domHelper";

class ZhiParallaxSection extends HTMLElement {
  _animationActive = false;
  _inViewport = false;

  connectedCallback() {
    MediaQueryService.getInstance();
    this.addEventListener(IN_VP_EVENT, () => this.handleInViewport());
    this.addEventListener(OUT_VP_EVENT, () => this.handleOutViewport());
    window.addEventListener(MQ_CHANGE_EVENT, () => this.handleMQChange());
    this.animationActive = this.activeOnCurrentMQ;
    ViewportObserverService.observe(this);
  }

  get image() {
    if (this._image === undefined) {
      this._image = this.querySelector(".zhi-parallax-section__image");
    }
    return this._image;
  }

  get activeOnCurrentMQ() {
    return getCurrentMQ() > "MQ1";
  }

  get animationActive() {
    return this._animationActive;
  }

  set animationActive(newValue) {
    if (this._animationActive === newValue) return;

    this._animationActive = newValue;
    this.updateAnimationFrame();
  }

  get imageOffsetHeight() {
    return window.innerHeight - this.image.offsetHeight;
  }

  get inViewport() {
    return this._inViewport;
  }

  set inViewport(newValue) {
    if (this._inViewport === newValue) return;

    this._inViewport = newValue;
    this.updateAnimationFrame();
  }

  get currentScrollOffset() {
    return this.getBoundingClientRect().top;
  }

  get scrollDistance() {
    return window.innerHeight + this.offsetHeight;
  }

  get componentOffset() {
    return this.scrollDistance - (this.getBoundingClientRect().top + this.offsetHeight);
  }

  get imageScrollDistance() {
    return this.scrollDistance - this.image.offsetHeight;
  }

  get imageOffset() {
    const componentOffset = this.componentOffset;
    const relativeImageProgress = this.imageScrollDistance / this.scrollDistance;
    const imageOffset = relativeImageProgress * componentOffset;
    const componentImageOffsetDelta = imageOffset - componentOffset;
    return (this.image.offsetHeight + componentImageOffsetDelta - this.offsetHeight / 2) * -1;
  }

  updateAnimationFrame() {
    if (this.animationActive && this.inViewport) {
      this.addAnimationFrame();
    } else if (this.animationFrameId !== undefined) {
      window.cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = undefined;
    }
  }

  addAnimationFrame() {
    if (this.animationFrameId !== undefined) return;
    this.animationFrameId = window.requestAnimationFrame(() => this.updateImageOffset());
  }

  updateImageOffset() {
    this.style.setProperty("--zhi-parallax-section__translateY", `${this.imageOffset}px`);
    this.animationFrameId = window.requestAnimationFrame(() => this.updateImageOffset());
  }

  handleMQChange() {
    this.animationActive = this.activeOnCurrentMQ;
  }

  handleInViewport() {
    this.inViewport = true;
  }

  handleOutViewport() {
    this.inViewport = false;
  }

}

customElements.define("zhi-parallax-section", ZhiParallaxSection);